// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================================================
   Report & Analytics — Scoped Styles
   All classes are prefixed with 'ra-' to avoid collisions
   =================================================================== */

/* Card */
.ra-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 1.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ra-card-header {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin-bottom: 0.25rem;
}

.ra-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  font-variant-numeric: tabular-nums;
}

/* Badges */
.ra-badge,
.ra-badge-green,
.ra-badge-red,
.ra-badge-yellow,
.ra-badge-blue,
.ra-badge-violet {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}
.ra-badge-green  { background: #d1fae5; color: #047857; }
.ra-badge-red    { background: #fee2e2; color: #b91c1c; }
.ra-badge-yellow { background: #fef3c7; color: #b45309; }
.ra-badge-blue   { background: #dbeafe; color: #1d4ed8; }
.ra-badge-violet { background: #ede9fe; color: #6d28d9; }

/* Select */
.ra-select-sm {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #334155;
  font-size: 0.875rem;
  border-radius: 0.5rem;
  padding: 0.375rem 0.75rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  outline: none;
}
.ra-select-sm:focus {
  box-shadow: 0 0 0 2px #3b82f6;
}

/* Tooltip (chart) */
.ra-tooltip {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* Spinner */
.ra-spinner {
  width: 2rem;
  height: 2rem;
  border: 2px solid #3b82f6;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ra-spin 0.8s linear infinite;
}
@keyframes ra-spin {
  to { transform: rotate(360deg); }
}

/* Layout utility classes */
.ra-flex { display: flex; }
.ra-flex-col { flex-direction: column; }
.ra-flex-1 { flex: 1 1; }
.ra-items-start { align-items: flex-start; }
.ra-items-center { align-items: center; }
.ra-items-baseline { align-items: baseline; }
.ra-justify-between { justify-content: space-between; }
.ra-justify-center { justify-content: center; }
.ra-gap-1 { gap: 0.25rem; }
.ra-gap-2 { gap: 0.5rem; }
.ra-gap-3 { gap: 0.75rem; }
.ra-gap-4 { gap: 1rem; }
.ra-mb-1 { margin-bottom: 0.25rem; }
.ra-mb-2 { margin-bottom: 0.5rem; }
.ra-mb-4 { margin-bottom: 1rem; }
.ra-mb-6 { margin-bottom: 1.5rem; }
.ra-mt-0\\.5 { margin-top: 0.125rem; }
.ra-mt-1 { margin-top: 0.25rem; }
.ra-h-48 { height: 12rem; }
.ra-w-2 { width: 0.5rem; }
.ra-h-2 { height: 0.5rem; }
.ra-rounded-full { border-radius: 9999px; }
.ra-text-center { text-align: center; }

/* Typography */
.ra-text-xl { font-size: 1.25rem; line-height: 1.75rem; }
.ra-text-sm { font-size: 0.875rem; line-height: 1.25rem; }
.ra-text-xs { font-size: 0.75rem; line-height: 1rem; }
.ra-font-bold { font-weight: 700; }
.ra-font-semibold { font-weight: 600; }
.ra-font-medium { font-weight: 500; }
.ra-font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }

/* Colors */
.ra-text-slate-400 { color: #94a3b8; }
.ra-text-slate-500 { color: #64748b; }
.ra-text-slate-700 { color: #334155; }
.ra-text-slate-800 { color: #1e293b; }
.ra-text-red-500 { color: #ef4444; }

/* Background dots */
.ra-bg-blue-500 { background-color: #3b82f6; }
.ra-bg-emerald-500 { background-color: #10b981; }
.ra-bg-amber-500 { background-color: #f59e0b; }
.ra-bg-red-500 { background-color: #ef4444; }
.ra-bg-violet-500 { background-color: #8b5cf6; }
`, "",{"version":3,"sources":["webpack://./src/features/reportAnalytics/reportAnalytics.css"],"names":[],"mappings":"AAAA;;;wEAGwE;;AAExE,SAAS;AACT;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA,WAAW;AACX;;;;;;EAME,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD,WAAW;AACX;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,2BAA2B;AAC3B,WAAW,aAAa,EAAE;AAC1B,eAAe,sBAAsB,EAAE;AACvC,aAAa,SAAO,EAAE;AACtB,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,mBAAmB,EAAE;AACxC,qBAAqB,qBAAqB,EAAE;AAC5C,sBAAsB,8BAA8B,EAAE;AACtD,qBAAqB,uBAAuB,EAAE;AAC9C,YAAY,YAAY,EAAE;AAC1B,YAAY,WAAW,EAAE;AACzB,YAAY,YAAY,EAAE;AAC1B,YAAY,SAAS,EAAE;AACvB,WAAW,sBAAsB,EAAE;AACnC,WAAW,qBAAqB,EAAE;AAClC,WAAW,mBAAmB,EAAE;AAChC,WAAW,qBAAqB,EAAE;AAClC,cAAc,oBAAoB,EAAE;AACpC,WAAW,mBAAmB,EAAE;AAChC,WAAW,aAAa,EAAE;AAC1B,UAAU,aAAa,EAAE;AACzB,UAAU,cAAc,EAAE;AAC1B,mBAAmB,qBAAqB,EAAE;AAC1C,kBAAkB,kBAAkB,EAAE;;AAEtC,eAAe;AACf,cAAc,kBAAkB,EAAE,oBAAoB,EAAE;AACxD,cAAc,mBAAmB,EAAE,oBAAoB,EAAE;AACzD,cAAc,kBAAkB,EAAE,iBAAiB,EAAE;AACrD,gBAAgB,gBAAgB,EAAE;AAClC,oBAAoB,gBAAgB,EAAE;AACtC,kBAAkB,gBAAgB,EAAE;AACpC,gBAAgB,6EAA6E,EAAE;;AAE/F,WAAW;AACX,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE;AACrC,mBAAmB,cAAc,EAAE;;AAEnC,oBAAoB;AACpB,kBAAkB,yBAAyB,EAAE;AAC7C,qBAAqB,yBAAyB,EAAE;AAChD,mBAAmB,yBAAyB,EAAE;AAC9C,iBAAiB,yBAAyB,EAAE;AAC5C,oBAAoB,yBAAyB,EAAE","sourcesContent":["/* ===================================================================\n   Report & Analytics — Scoped Styles\n   All classes are prefixed with 'ra-' to avoid collisions\n   =================================================================== */\n\n/* Card */\n.ra-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  padding: 1.25rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ra-card-header {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  margin-bottom: 0.25rem;\n}\n\n.ra-stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Badges */\n.ra-badge,\n.ra-badge-green,\n.ra-badge-red,\n.ra-badge-yellow,\n.ra-badge-blue,\n.ra-badge-violet {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.125rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n.ra-badge-green  { background: #d1fae5; color: #047857; }\n.ra-badge-red    { background: #fee2e2; color: #b91c1c; }\n.ra-badge-yellow { background: #fef3c7; color: #b45309; }\n.ra-badge-blue   { background: #dbeafe; color: #1d4ed8; }\n.ra-badge-violet { background: #ede9fe; color: #6d28d9; }\n\n/* Select */\n.ra-select-sm {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  color: #334155;\n  font-size: 0.875rem;\n  border-radius: 0.5rem;\n  padding: 0.375rem 0.75rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  outline: none;\n}\n.ra-select-sm:focus {\n  box-shadow: 0 0 0 2px #3b82f6;\n}\n\n/* Tooltip (chart) */\n.ra-tooltip {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.75rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n/* Spinner */\n.ra-spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 2px solid #3b82f6;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: ra-spin 0.8s linear infinite;\n}\n@keyframes ra-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Layout utility classes */\n.ra-flex { display: flex; }\n.ra-flex-col { flex-direction: column; }\n.ra-flex-1 { flex: 1; }\n.ra-items-start { align-items: flex-start; }\n.ra-items-center { align-items: center; }\n.ra-items-baseline { align-items: baseline; }\n.ra-justify-between { justify-content: space-between; }\n.ra-justify-center { justify-content: center; }\n.ra-gap-1 { gap: 0.25rem; }\n.ra-gap-2 { gap: 0.5rem; }\n.ra-gap-3 { gap: 0.75rem; }\n.ra-gap-4 { gap: 1rem; }\n.ra-mb-1 { margin-bottom: 0.25rem; }\n.ra-mb-2 { margin-bottom: 0.5rem; }\n.ra-mb-4 { margin-bottom: 1rem; }\n.ra-mb-6 { margin-bottom: 1.5rem; }\n.ra-mt-0\\.5 { margin-top: 0.125rem; }\n.ra-mt-1 { margin-top: 0.25rem; }\n.ra-h-48 { height: 12rem; }\n.ra-w-2 { width: 0.5rem; }\n.ra-h-2 { height: 0.5rem; }\n.ra-rounded-full { border-radius: 9999px; }\n.ra-text-center { text-align: center; }\n\n/* Typography */\n.ra-text-xl { font-size: 1.25rem; line-height: 1.75rem; }\n.ra-text-sm { font-size: 0.875rem; line-height: 1.25rem; }\n.ra-text-xs { font-size: 0.75rem; line-height: 1rem; }\n.ra-font-bold { font-weight: 700; }\n.ra-font-semibold { font-weight: 600; }\n.ra-font-medium { font-weight: 500; }\n.ra-font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }\n\n/* Colors */\n.ra-text-slate-400 { color: #94a3b8; }\n.ra-text-slate-500 { color: #64748b; }\n.ra-text-slate-700 { color: #334155; }\n.ra-text-slate-800 { color: #1e293b; }\n.ra-text-red-500 { color: #ef4444; }\n\n/* Background dots */\n.ra-bg-blue-500 { background-color: #3b82f6; }\n.ra-bg-emerald-500 { background-color: #10b981; }\n.ra-bg-amber-500 { background-color: #f59e0b; }\n.ra-bg-red-500 { background-color: #ef4444; }\n.ra-bg-violet-500 { background-color: #8b5cf6; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
